__turbopack_context__.v({
  "rotate": "LoadingSpinner-module-scss-module__YJM1WG__rotate",
  "spinner": "LoadingSpinner-module-scss-module__YJM1WG__spinner",
  "spinner--lg": "LoadingSpinner-module-scss-module__YJM1WG__spinner--lg",
  "spinner--light": "LoadingSpinner-module-scss-module__YJM1WG__spinner--light",
  "spinner--md": "LoadingSpinner-module-scss-module__YJM1WG__spinner--md",
  "spinner--sm": "LoadingSpinner-module-scss-module__YJM1WG__spinner--sm",
  "spinner--xl": "LoadingSpinner-module-scss-module__YJM1WG__spinner--xl",
  "spinner--xs": "LoadingSpinner-module-scss-module__YJM1WG__spinner--xs",
});
